import { Component, Renderer2, ViewChildren, QueryList,
         ElementRef, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { ValidationService } from '../../services/validation';
import { ZipRequestsService } from '../../providers';
import { FEATURES, TEXT_MASKS } from '../../constants';
import forEach from 'lodash-es/forEach';
import values from 'lodash-es/values';

@Component({
  selector: 'home-page',
  styleUrls: ['./home.scss'],
  templateUrl: './home.pug'
})

export class HomeComponent implements OnInit {
  public features = FEATURES;
  public submitted: boolean;
  public textMasks = TEXT_MASKS;
  public zipForm: FormGroup;
  cuisines: Array<string> = [
    'american', 'asian', 'breakfast', 'chinese', 'desserts', 'italian',
    'mediterranean', 'mexican', 'pizza', 'thai', 'vegeterian', 'wings'
  ];
  public Features_check_mark = require('../../resources/images/features_check_mark.png');

  constructor(private router: Router,
              private renderer: Renderer2,
              private toastr: ToastsManager,
              private zipService: ZipRequestsService,
              private _fb: FormBuilder) {}

  public ngOnInit () {
    this.zipForm = this._fb.group(this.formInit());
  }

  public submitForm() {
    this.submitted = true;
    if (this.zipForm.valid) {
      this.zipService.createRequest(this.zipForm.value).subscribe((data) => {
        this.resetZipForm();
        this.toastr.success('You subscribed successfully!');
      }, (err) => {
        let error = values(err['error'])[0][0];
        this.toastr.warning(error);
      });
    }
  }

  private formInit() {
    const user = {
      email: ['', Validators.compose([Validators.required, ValidationService.emailValidator])],
      zip_code: ['', Validators.compose([Validators.required, ValidationService.minFilteredLength(5)])]
    };
    return user;
  }

  private resetZipForm() {
    this.submitted = false;
    this.zipForm.get('email').patchValue('');
    this.zipForm.get('zip_code').patchValue('');
    this.zipForm.markAsUntouched();
  }
}



// WEBPACK FOOTER //
// ./src/components/home/home.ts